export const GQL_USER_DEFAULT_FIELDS = `
  id
  roleId
  firstname
  lastname
  contactEmail
  contactPhone
  companyName
  preferredLanguage
  lastLoginAt
  createdBy {
    id
    username
    firstname
    lastname
    date
  }
  updatedBy {
    id
    username
    firstname
    lastname
    date
  }
  hiddenBy {
    id
    username
    firstname
    lastname
    date
  }
  deletedBy {
    id
    username
    firstname
    lastname
    date
  }
  restrictedBy {
    id
    username
    firstname
    lastname
    date
  }
  projects {
    id
    title
    key
    archived
    paused
  }`
